import { render, staticRenderFns } from "./privacity-policy.vue?vue&type=template&id=68eda6d0&scoped=true&"
import script from "./privacity-policy.vue?vue&type=script&lang=js&"
export * from "./privacity-policy.vue?vue&type=script&lang=js&"
import style0 from "./privacity-policy.vue?vue&type=style&index=0&id=68eda6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eda6d0",
  null
  
)

export default component.exports